<template>
  <div class="backStack-issue-wrap informationCreate" >
    <div class="form-scroll-wrap" :style="contentStyle">
      <From
        ref="formRef"
        layoutType="grid"
        :isErrorMessage="false"
        :optionList="formRows"
        :formRules="formRules"
        :defaultModel="defaultModel">
      </From>
    </div>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <!-- <a-button class="submit-audit" @click="preView">保存</a-button> -->
        <a-button class="submit-audit" @click="toAudit(0)">保存</a-button>
        <a-button class="submit-audit" @click="toAudit(1)">保存并发布</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
// import mixinFakeData from '@/mixins/makeFakerData  '
import { formRules, formRows } from './configs/formOptions.js'
import {addFinanceInfo} from '@/api/serverInfo.js'

export default {
  mixins: [mixinsBackStack, mixinConfigSetting],
  data() {
    return {
      loading: true,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: { },
      isRead: false,
      contentStyle: ''
    }
  },
  components: {
    From
  },
  mounted() {
    this.initDom()
  },
  methods: {
    initDom() {
      this.contentStyle ={ height: `calc(100vh - 360px)` }
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    async toAudit(status) {
      const v = this.$refs.formRef.validatedForm()
      if (!v) return
      try {
        const {title, financialType, content, ...formValue} = this.$refs.formRef.formModel
        const contentVos =  this.assignResult(formValue)
        const annexIds = this.handlerAnnexIds(formValue).join(',')
        const pic = this.handlerPicPathIds(formValue).join(',')
        const params = {
          contentVos,
          annexIds,
          pic,
          title,
          financialType,
          content,
          status
        }
        // console.log(params, formValue)
        const {msg, code} = await addFinanceInfo(params)
        this.$apiStatusHandler(code, msg)
        this.$router.push({ name: 'serverInfos' })
      } catch (error) {
        console.log(error)
        this.$apiStatusHandler(99, error)
      }

    },
    handlerAnnexIds(instance) {
      const { annexIds } = instance
      if(!annexIds) return []
      return annexIds.reduce((pre, item) => {
        const {fileId} = item.response.data[0]
        pre.push(fileId)
        return pre
      }, [])
    },
    handlerPicPathIds(instance) {
      const { picPath } = instance
      if(!picPath) return []
      return picPath.reduce((pre, item) => {
        const {fileId} = item.response.data[0]
        pre.push(fileId)
        return pre
      }, [])
    },
    assignResult(result) {
      const key1 = '-content'
      const key2 = '-section'
      const map = new Map()
      const resultParams = {} // 最终回显
      Object.keys(result).forEach(key => {
        const includes1 = key.indexOf(key1) !== -1
        const includes2 = key.indexOf(key2) !== -1
        if(includes1 || includes2) {
          const [idx, k] = key.split('-')
          const have = map.has(idx)
          const v = result[key] || ''
          if(have) {
            const t = map.get(idx)
            t[k] = v
            map.set(idx, t)
          } else {
            map.set(idx, {[k]:v})
          }
        } else {
          resultParams[key] = result[key]
        }
      })
      const list = [...map].map(item => item[1])
      return list
    },
    // preView() {
    //   const formValue = this.$refs.formRef.formModel
    //   console.log(formValue)
    // }
  }
}
</script>
